module.exports = __webpack_public_path__ + "static/img/flowChart4.829a6e5e.jpg";